import { render, staticRenderFns } from "./RedeemTreasureView.vue?vue&type=template&id=ebc90b76&scoped=true"
import script from "./RedeemTreasureView.vue?vue&type=script&lang=js"
export * from "./RedeemTreasureView.vue?vue&type=script&lang=js"
import style0 from "./RedeemTreasureView.vue?vue&type=style&index=0&id=ebc90b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc90b76",
  null
  
)

export default component.exports